import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VStepper,{model:{value:(_vm.currentStep),callback:function ($$v) {_vm.currentStep=$$v},expression:"currentStep"}},[_c(VStepperItems,_vm._l((_vm.stepsCount),function(n){return _c(VStepperContent,{key:("stepper-content-" + n),attrs:{"step":n}},[_c('ValidationObserver',{ref:("step-" + n),refInFor:true,attrs:{"slim":""}},[_vm._t(("step-" + n))],2)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }